import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import envValues from '../../enviornment';

function OneRepTable({ unit }) {
  const { userId } = useParams();

  const [tableData, setTableData] = useState([]);

  const getOneRepTableData = async () => {
    try {
      const response = await axios.get(
        `${envValues.REACT_APP_API_ENDPOINT}/statistics/1rm-exercises-with-rm/${userId}`
      );
      setTableData(response.data.data.exercises.exercises);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getOneRepTableData();
  }, []);

  return (
    <div>
      <Table responsive>
        <thead>
          <tr>
            <th>Exercise</th>
            <th>1RM</th>
            <th>-5% (Training Max)</th>
            <th>-10% (Training Max)</th>
          </tr>
        </thead>
        <tbody>
          {tableData?.map((item) => (
            <tr>
              <td>{item?.exerciseName}</td>
              <td>
                {item?.rm} {unit}
              </td>
              <td>
                {item?.rm95} {unit}
              </td>
              <td>
                {item?.rm90} {unit}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
OneRepTable.propTypes = {
  unit: PropTypes.string,
};

OneRepTable.defaultProps = {
  unit: '',
};

export default OneRepTable;
